import React, { useEffect } from "react";
import { Autocomplete, TextField } from "@mui/material";

export const DocumentAutocomplete = ({
  documentID,
  setDocumentID,
  setNameDocument,
  documents = [],
  loading = false,
}) => {
  const documentOptions = documents.map((doc) => ({
    id: `${doc.ID_DOCUMENTO}`,
    label: doc.NOMBRE_DOCUMENTO,
  }));

  const selectedDocument = documentOptions.find((doc) => doc.id === documentID) || null;

  useEffect(() => {
    if (selectedDocument) {
      setNameDocument(selectedDocument.label);
    }
  }, [setNameDocument, selectedDocument]);

  const handleSelectionChange = (event, value) => {
    if (value) {
      setDocumentID(value.id);
      setNameDocument(value.label);
    } else {
      setDocumentID(null);
      setNameDocument("");
    }
  };

  return (
    <div>
      <Autocomplete
        disablePortal
        freeSolo
        size="small"
        options={documentOptions}
        getOptionLabel={(option) => option.label || ""}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        loading={loading}
        value={selectedDocument}
        onChange={handleSelectionChange}
        renderOption={(props, option) => (
          <li {...props} key={option.id}>
            {option.label}
          </li>
        )}
        renderInput={(params) => <TextField {...params} label="Buscar documento" />}
      />
    </div>
  );
};
